import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BankDetails from "../../../../components/_utils/AccountCreationComponents/BankDetails";
import ConfirmBtnAccCreation from "../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import ActiveInactiveAssociatePopup from "../../../_utils/ActiveInactiveAssociatePopup";
import ICONS from "../../../../assets/Icons";
import ConfidentialCard from "../../../_utils/TransactionCommonComponents/ConfidentialCard";
import TEXT from "../../../../utils/globalText";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CommonLayout from "../../../_utils/CommonLayout";

const FieldFieldBankDetails = ({
  setBankLookupNext,
  bankLookupNext,
  nextButtonEnabled,
  BenEnableNextButton,
  payload,
  setPayload,
  activeStep,

  setBankIsArchived,
  setBankIsApproved,
  setBankIsDennied,

  setBankIsPending,
  ownerAccIfscError,
  setBankDisableCreateNext,
  setBankAccountType,
  manualVirtualAccount,
  setManualVirtualAccount,
  ownerAccIfscData,
  hideBankBlock,
  setBankHideBlock,
  isButtonDisabled,
  setBankUserInfo,
  bankVerificationStatus,
  setBankVerificationStatus,
  isIFSCValid,
  isBankError,
  virtualAccount,
  setVirtualAccount,
  previousId,
  setPreviousBankNo,
}) => {
  const {
    beneLookData,
    benebankLookData,
    beneLookLoading,
    verifyBankisLoading,
  } = useSelector((state) => state.beneAllVerification);

  const { ownerAccIfscLoading } = useSelector(
    (state) => state.ownerAllVerification,
  );

  const ifscData = ownerAccIfscData?.ifsc_details?.[0];

  const accounts = benebankLookData?.beneficiary_accounts || [];

  const shouldShowNoAssociatedMsg =
    !beneLookLoading &&
    bankVerificationStatus === true &&
    !virtualAccount &&
    payload.bank_account?.length >= GlobalConfiguration?.accountnormalLength &&
    payload.ifsc_code?.length === GlobalConfiguration?.ifscLength &&
    accounts.length === GlobalConfiguration?.lengthCheckZero;

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.find((val) => {
      if (val?.approval_status === "approved") {
        if (val?.id === previousId) {
          setPreviousBankNo(val?.bank_acc_no);
        }
      }
    });
  }, [beneLookData]);

  const [isBankLinkedAccount, setIsBankLinkedAccount] = useState(false);
  const [isCreateAccount, setIsCreateAccount] = useState(false);
  const dropDownOptions = [
    "Field force account",
    "Beneficiary account",
    "Reimbursement account",
    "Tax account",
  ];

  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(
    "Field force account",
  );
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);

  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    if (
      !beneLookLoading &&
      !verifyBankisLoading &&
      beneLookData?.beneficiary_accounts?.length ===
        GlobalConfiguration?.lengthCheckZero &&
      !isBankError &&
      isIFSCValid &&
      !virtualAccount
    ) {
      setShowDetails(true);
    }
  }, [beneLookLoading, verifyBankisLoading, beneLookData]);

  useEffect(() => {
    const foundAccount = beneLookData?.beneficiary_accounts?.find((val) => {
      if (
        payload?.panNumber === val?.pan_no &&
        payload?.bank_account === val?.bank_acc_no &&
        payload?.ifsc_code === val?.ifsc_code
      ) {
        setIsBankLinkedAccount(true);
        setIsCreateAccount(true);

        return true;
      }
      return false;
    });

    if (foundAccount) {
      setCurrentAssociate(
        foundAccount?.type_of_account === "field_force"
          ? "Field force account"
          : foundAccount?.type_of_account === "reimbursement"
            ? "Reimbursement account"
            : foundAccount?.type_of_account === "tds"
              ? "Tax account"
              : "Beneficiary account",
      );
      setAccActiveInactiveState(
        foundAccount?.approval_status === "rejected" ||
          foundAccount?.approval_status === "blocked" ||
          foundAccount?.approval_status === "archived"
          ? "inactive"
          : "active",
      );
    }

    if (!foundAccount) {
      setIsBankLinkedAccount(false);
      setIsCreateAccount(false);
    }
  }, [beneLookData, payload]);

  return (
    <>
      <div className="px-padding-md lg:px-padding-base pb-padding-md py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <div className="w-width-full">
            {hideBankBlock && !isBankError && !virtualAccount ? (
              <div className="bene_block_message_text">
                <img
                  src={
                    "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                  }
                  alt="info"
                  className="h-icon-md mr-margin-sm"
                />
                <p>To unblock this account, please contact customer support</p>
              </div>
            ) : isBankLinkedAccount && isIFSCValid ? (
              <div className="bank_new_message_text_block_nonarchive">
                <img
                  src="https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                  alt="info"
                  className="h-icon-md mr-margin-sm"
                />
                <p>
                  The bank account is already linked to the PAN provided. To
                  proceed, update either the bank details or the PAN associated
                  with the profile.
                </p>
              </div>
            ) : null}
            {virtualAccount && isIFSCValid ? (
              <>
                <div className="flex flex-row gap-x-gap-sm bg-emphasis p-padding-md mb-margin-md rounded-border-radius-md">
                  <img
                    src={ICONS.VIRTUAL_ACCOUNT}
                    alt="Virtual Account"
                    className="w-icon-md h-icon-md"
                  />
                  <div className="flex flex-col gap-y-gap-sm">
                    <p className="text-font-sm text-text-primary font-semibold">
                      Virtual Account Detected
                    </p>
                    <ul className="flex flex-col gap-y-gap-sm list-disc list-inside ml-margin-xs">
                      <li className="text-font-xs text-text-primary font-normal">
                        Account could not be verified as it is virtual account.
                      </li>
                      <li className="text-font-xs text-text-primary font-normal">
                        Please self verify and proceed with caution.
                      </li>
                    </ul>
                  </div>
                </div>
              </>
            ) : null}
            <div className="h-fit w-full lg:max-w-[var(--create-box-width)]">
              <BankDetails
                payload={payload}
                setPayload={setPayload}
                BenEnableNextButton={BenEnableNextButton}
                activeStep={activeStep}
                setVirtualAccount={setVirtualAccount}
                setBankUserInfo={setBankUserInfo}
                bankLookupNext={bankLookupNext}
                setBankLookupNext={setBankLookupNext}
                bankVerificationStatus={bankVerificationStatus}
                setBankVerificationStatus={setBankVerificationStatus}
                virtualAccount={virtualAccount}
                isIFSCValid={isIFSCValid}
                setShowDetails={setShowDetails}
                manualVirtualAccount={manualVirtualAccount}
                setManualVirtualAccount={setManualVirtualAccount}
                ifscData={ifscData}
                ownerAccIfscError={ownerAccIfscError}
                ownerAccIfscLoading={ownerAccIfscLoading}
              />
            </div>
          </div>
          <div
            className={`w-width-full flex flex-col lg:max-w-[var(--create-box-width)]`}
          >
            {isBankError === true &&
              ownerAccIfscError === false &&
              !ownerAccIfscLoading && (
                <ConfidentialCard
                  icon={ICONS.VIRTUAL_ACCOUNT}
                  title={TEXT?.MARK_VIRTUAL_ACCOUNT}
                  note={TEXT?.VIRTUAL_ACCOUNT_NOTE}
                  toggleState={manualVirtualAccount}
                  onToggle={() => {
                    const nextState = !manualVirtualAccount;
                    setManualVirtualAccount(nextState);
                    setBankVerificationStatus(!bankVerificationStatus);
                    setPayload({
                      ...payload,
                      virtual: nextState ? true : false,
                    });
                  }}
                />
              )}

            <ConfirmBtnAccCreation
              type="bank"
              status={
                beneLookData?.beneficiary_accounts?.length >
                GlobalConfiguration?.lengthCheckZero
              }
              isIFSCValid={isIFSCValid}
              isBankError={isBankError}
              lookupNext={bankLookupNext}
              isButtonDisabled={isBankLinkedAccount && isIFSCValid}
              nextButtonEnabled={nextButtonEnabled}
              handleClick={() => {
                if (!isButtonDisabled && !isCreateAccount) {
                  setIsCreateAccount(false);
                  setBankIsApproved(false);
                  setBankLookupNext(true);
                  setBankIsArchived(false);
                  setBankIsDennied(false);
                  setBankIsPending(false);
                  setBankHideBlock(false);
                  setBankDisableCreateNext(false);
                  if (bankLookupNext) {
                    BenEnableNextButton(true);
                  } else {
                    BenEnableNextButton(false);
                  }
                  if (bankLookupNext) {
                    setBankLookupNext(false);
                  }
                  setBankAccountType({ type: "", id: "" });
                  setBankDisableCreateNext(true);
                } else {
                  return;
                }
              }}
            />

            <div
              style={{
                display:
                  (beneLookData?.status &&
                    beneLookData?.beneficiary_accounts?.length >
                      GlobalConfiguration?.lengthCheckZero &&
                    isIFSCValid &&
                    !isBankError) ||
                  showDetails
                    ? "block"
                    : "none",
              }}
            >
              <ActiveInactiveAssociatePopup
                flow={
                  isBankLinkedAccount && isIFSCValid
                    ? "Existing"
                    : showDetails
                      ? "notFoundBank"
                      : "Bank"
                }
                dropDownOptions={dropDownOptions}
                ifsc={payload?.ifsc_code}
                bank={payload?.bank_account}
                pan={payload?.panNumber}
                accActiveInactiveState={accActiveInactiveState}
                setAccActiveInactiveState={setAccActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={setOpenAssociatePopup}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};
export default FieldFieldBankDetails;
